import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/lib/services/common.service';
import { StorageService } from 'src/app/lib/services/storage.service';
import { Constants } from 'src/app/config/constants';
import { OnboardService } from 'src/app/lib/services/onboard.service';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-my-qr',
  templateUrl: './my-qr.component.html',
  styleUrls: ['./my-qr.component.scss'],
  standalone: false
})
export class MyQrComponent implements OnInit {
  shopId: string;
  shopQR = ''
  responseSuccess: any
  shopDetails: any
  shopName: any;
  shopAddress: any;
  userData: any;
  addDisable: boolean;

  constructor(
    public commonservice: CommonService,
    private storageService: StorageService,
    private onboardService: OnboardService
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.getShopOwnerDetails()
  }

  getSanitizedAddress(): string {
    const { shop_number, locality, city, pincode, state } = this.shopDetails || {};
    return [shop_number, locality, city, pincode, state].filter(Boolean).join(', ');
  }

  getShopOwnerDetails() {
    this.commonservice.presentLoader().then(loading => {
      this.shopId = this.commonservice.getUserData() && this.commonservice.getUserData().shopId
        ? this.commonservice.getUserData().shopId : this.storageService.getItem(Constants.SHOP_ID);
      loading.present();

      /**
       * @function Profile function is being called
       */
      this.onboardService.getShopOwnerDetails(this.shopId ? this.shopId : null).subscribe((shopDetails: any) => {
        loading.dismiss();
        this.responseSuccess = shopDetails.success;
        this.shopDetails = shopDetails.data.shop;
        this.shopName = shopDetails.data?.shop?.shop_name;
        this.shopQR = shopDetails.data?.shop?.profileUrl;
      }, error => {
        console.log(error);
        loading.dismiss();
      });
    });
  }

  getCategoriesList() {
    if (this.shopDetails?.category) return this.shopDetails?.category.filter((res: any) => res.name !== 'All');
  }

  // shareQr() {
  //   this.addDisable = true;
  //   if (navigator.share) {
  //     navigator.share({
  //       title: this.shopName,
  //       text: `Scan this qr to visit ${this.shopName}.`,
  //       url: this.shopQR
  //     });
  //   }
  //   this.addDisable = false;
  // }

  shareQr() {
    this.addDisable = true;

    try {
      // Check if Web Share API is supported
      if (navigator.share) {
        navigator.share({
          title: this.shopName,
          text: `Click on the link to visit ${this.shopName}.`,
          url: this.shopQR
        }).catch(error => {
          console.error('Error sharing:', error);
        });
      } else {
        // Fallback for browsers that don't support Web Share API (like Firefox)
        const fallbackText = `Click on the link to visit ${this.shopName}.\n${this.shopQR}`;

        // Create a temporary textarea element to copy text to clipboard
        const textArea = document.createElement('textarea');
        textArea.value = fallbackText;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        alert('Shop information copied to clipboard! You can now paste it wherever you want to share.');
      }
    } catch (error) {
      console.error('Error in share function:', error);
      alert('Unable to share. Please copy the information manually.');
    } finally {
      this.addDisable = false;
    }
  }

  downloadQr() {
    const pageElement = document.getElementById('download');
    html2canvas(pageElement, { logging: true, useCORS: true }).then(canvas => {
      const imageDataURL = canvas.toDataURL('image/jpeg');
      const link = document.createElement('a');
      link.href = imageDataURL;
      link.download = `${this.shopName}_qr.jpg`;
      link.click();
    });
  }
}
